import SearchTree from './SearchTree';

export default (props) => {
  return <SearchTree {...props} />;
};
